/** Message d'erreur API toujours rendu sous forme de chaîne (FastAPI renvoie une liste d'objets en 422). */
export const errMsg = (error, fallback = 'Une erreur est survenue') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (typeof first === 'string') return first;
    if (first?.msg) return first.msg;
  }
  if (typeof error?.message === 'string' && error.message) return error.message;
  return fallback;
};

export default errMsg;
